var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3847_30679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1937 11.0542L14.5833 20.6646L9.34788 15.4437L7.29163 17.5L14.5833 24.7917L26.25 13.125L24.1937 11.0542ZM17.5 2.91666C9.44996 2.91666 2.91663 9.44999 2.91663 17.5C2.91663 25.55 9.44996 32.0833 17.5 32.0833C25.55 32.0833 32.0833 25.55 32.0833 17.5C32.0833 9.44999 25.55 2.91666 17.5 2.91666ZM17.5 29.1667C11.0541 29.1667 5.83329 23.9458 5.83329 17.5C5.83329 11.0542 11.0541 5.83332 17.5 5.83332C23.9458 5.83332 29.1666 11.0542 29.1666 17.5C29.1666 23.9458 23.9458 29.1667 17.5 29.1667Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3847_30679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.7ae5f8534d48594a7fd93cf02a8fddb2.svg";
export { ForwardRef as ReactComponent };